import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const MyLeadsSVG = ({ ...props }) => {
  return (
    <Svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_103_2618)">
        <Rect x={-0.00012207} width={48} height={48} rx={8} fill="#F2F7FF" />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.284 28.656c3.1.167 5.476 2.763 5.305 5.798-.17 3.035-2.823 5.36-5.924 5.193-3.1-.167-5.476-2.763-5.305-5.798.17-3.035 2.823-5.36 5.924-5.193zm9.14 20.7H14.04c-.411 0-.765-.162-1.017-.466a1.106 1.106 0 01-.23-1.035c1.254-4.546 5.676-7.905 10.94-7.905 5.262 0 9.684 3.359 10.938 7.905.102.372.022.732-.23 1.035a1.283 1.283 0 01-1.017.465z"
          fill="url(#paint0_radial_103_2618)"
        />
        <Path
          d="M24.752 13.506c-.365-.723-1.413-.723-1.778 0l-1.325 2.622a.992.992 0 01-.743.532l-2.944.428c-.811.118-1.135 1.099-.55 1.664l2.126 2.049a.967.967 0 01.284.86l-.495 2.886c-.137.796.711 1.402 1.438 1.029l2.638-1.355c.288-.148.631-.148.92 0l2.637 1.355c.727.373 1.575-.233 1.439-1.029l-.495-2.886a.967.967 0 01.284-.86l2.125-2.049c.586-.565.262-1.546-.55-1.664l-2.943-.428a.992.992 0 01-.744-.532l-1.324-2.622z"
          fill="url(#paint1_radial_103_2618)"
        />
        <Path
          d="M9.495 22.15a.8.8 0 011.413 0l1.027 1.968c.116.22.33.374.58.414l2.22.353c.638.102.892.871.436 1.322l-1.584 1.57a.773.773 0 00-.222.67l.345 2.186c.099.629-.567 1.104-1.144.817l-2.006-.998a.806.806 0 00-.717 0l-2.007.998c-.577.287-1.242-.188-1.143-.817l.344-2.186a.774.774 0 00-.221-.67l-1.585-1.57c-.455-.45-.201-1.22.437-1.322l2.22-.353a.794.794 0 00.58-.414l1.027-1.968z"
          fill="url(#paint2_radial_103_2618)"
        />
        <Path
          d="M38.092 22.15a.8.8 0 011.413 0l1.027 1.968c.116.22.33.375.58.414l2.22.354c.638.101.892.87.436 1.322l-1.584 1.569a.773.773 0 00-.222.67l.345 2.186c.099.629-.567 1.104-1.144.817l-2.006-.997a.806.806 0 00-.717 0l-2.007.997c-.577.287-1.242-.188-1.143-.817l.344-2.186a.774.774 0 00-.221-.67l-1.585-1.57c-.455-.45-.201-1.22.437-1.322l2.22-.353a.794.794 0 00.58-.414l1.027-1.967z"
          fill="url(#paint3_radial_103_2618)"
        />
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_103_2618"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(133.425 10.253 21.675) scale(26.9799 25.052)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_103_2618"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(153.773 17.542 11.837) scale(40.1677 27.8149)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="paint2_radial_103_2618"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(153.773 17.542 11.837) scale(40.1677 27.8149)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="paint3_radial_103_2618"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(153.773 17.542 11.837) scale(40.1677 27.8149)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <ClipPath id="clip0_103_2618">
          <Rect x={-0.00012207} width={48} height={48} rx={8} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default MyLeadsSVG
